"use strict";

var makeArray = function makeArray(element) {
  return Array.prototype.slice.call(element);
};